import {
  blue100,
  blueVioletDesat35,
  brownYellow25,
  brownYellow180,
  fluorescentBlueViolet69,
  fluorescentCyan185,
  fluorescentPink119,
  greenBlue100,
  greenBlueDesat155,
  orange100,
  orange135,
  pink115,
  violet155,
  violetPinkDesat100,
  yellowGreen100,
  yellowGreen135,
} from '@spotify-internal/encore-foundation';

export type ChartColorType =
  | 'pink'
  | 'flourescent'
  | 'yellowGreen'
  | 'brownYellow'
  | 'violet'
  | 'greenBlue'
  | 'blue'
  | 'orange'
  | 'greenBlueDesat';

const chartColors: {
  light: Record<ChartColorType, string>;
  dark: Record<ChartColorType, string>;
} = {
  light: {
    pink: fluorescentPink119,
    flourescent: fluorescentBlueViolet69,
    yellowGreen: yellowGreen100,
    brownYellow: brownYellow25,
    violet: violetPinkDesat100,
    greenBlue: greenBlue100,
    blue: blue100,
    orange: orange100,
    greenBlueDesat: blueVioletDesat35,
  },
  dark: {
    pink: pink115,
    flourescent: fluorescentCyan185,
    yellowGreen: yellowGreen135,
    brownYellow: brownYellow180,
    violet: violet155,
    greenBlue: greenBlue100,
    blue: blue100,
    orange: orange135,
    greenBlueDesat: greenBlueDesat155,
  },
};

export const getChartColors = (mode: 'light' | 'dark') => {
  return mode === 'light' ? chartColors.light : chartColors.dark;
};

export const defaultChartColors: ChartColorType[] = [
  'pink',
  'flourescent',
  'yellowGreen',
  'violet',
  'blue',
  'greenBlue',
  'orange',
  'greenBlueDesat',
  'brownYellow',
];

export const confidenceBlueTonalScale = [
  '#F8FAFC',
  '#E8F8FF',
  '#D0F2FF',
  '#B9EBFF',
  '#A1E5FF',
  '#73D7FF',
  '#44CAFF',
  '#15BDFF',
  '#1197CC',
  '#0D7199',
] as const;

const confidenceBlueCategoricalColors: Record<
  'light' | 'dark',
  readonly string[]
> = {
  light: [
    confidenceBlueTonalScale[9],
    confidenceBlueTonalScale[8],
    confidenceBlueTonalScale[5],
    confidenceBlueTonalScale[7],
  ],
  dark: [
    confidenceBlueTonalScale[8],
    confidenceBlueTonalScale[6],
    confidenceBlueTonalScale[2],
    confidenceBlueTonalScale[9],
  ],
};

const confidenceDistinctCategoricalColorTypes: readonly ChartColorType[] = [
  'pink',
  'flourescent',
  'yellowGreen',
  'brownYellow',
  'violet',
  'greenBlue',
  'blue',
  'orange',
];

export const confidenceBlueOrdinalScale = [
  ...confidenceBlueTonalScale,
].reverse();

const confidencePrimaryChartColors: Record<'light' | 'dark', string> = {
  light: confidenceBlueTonalScale[8],
  dark: confidenceBlueTonalScale[7],
};

export const getConfidenceBlueCategoricalColors = (
  mode: 'light' | 'dark',
): readonly string[] => confidenceBlueCategoricalColors[mode];

export const getConfidenceDistinctCategoricalColors = (
  mode: 'light' | 'dark',
): readonly string[] =>
  confidenceDistinctCategoricalColorTypes.map(
    colorType => chartColors[mode][colorType],
  );

export const getConfidencePrimaryChartColor = (
  mode: 'light' | 'dark',
): string => confidencePrimaryChartColors[mode];
